import { type FC, type ReactNode } from 'react';

import { useSelector } from 'react-redux';

import { RestrictedAccessRoute } from 'components/restricted-access-route/RestrictedAccessRoute';
import { shouldRestrictAgentAccess } from 'store/features/session/selectors';

interface IAgentAccessGuardProps {
  children: ReactNode;
  redirectTo?: string;
}

/**
 * Router-level guard component that prevents agents with agents_permissions_restricted
 * property from accessing restricted areas of the application.
 *
 * Based on AC-1031 requirements:
 * - Silent redirect to dashboard/home when restricted path is accessed
 * - Admins and owners bypass all restrictions regardless of property value
 * - Property values: "0" (disabled), "1" (enabled), undefined (disabled)
 */
export const AgentAccessGuard: FC<IAgentAccessGuardProps> = ({ children, redirectTo = '/home' }) => {
  const isAgentAccessRestricted = useSelector(shouldRestrictAgentAccess);

  return (
    <RestrictedAccessRoute
      canAccessView={!isAgentAccessRestricted}
      noAccessRedirectUrl={redirectTo}
      render={() => <>{children}</>}
    />
  );
};
